<app-content>
  <app-breadcrumbs>
    <li>
      Płatności online
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Płatności online
    </h2>
    <app-payment-status-checker [paymentToken]='paymentToken' [canDownload]='true'>
    </app-payment-status-checker>
    <br>
    <div class='d-flex justify-content-end'>
      <a *ngIf='appId && serviceType && authed'
         [routerLink]='["/wnioski-zatwierdzone/" + serviceType, appId]'
         [queryParams]='{ pt: paymentToken }'
         class='btn btn-secondary'>
        Wróć do sprawy
      </a>
      <a *ngIf='!appId' routerLink='/' class='btn btn-secondary'>Przejdź na stronę główną</a>
    </div>
  </section>
</app-content>
